// extracted by mini-css-extract-plugin
export var section = "styles-module--section--jVV1v";
export var container = "styles-module--container--1xlRb";
export var title = "styles-module--title--E17S5";
export var subtitle = "styles-module--subtitle--1Wl0O";
export var gridImagesContainer = "styles-module--gridImagesContainer--1Ny_9";
export var gridImage = "styles-module--gridImage--1e_tt";
export var gridImageTitle = "styles-module--gridImageTitle--3JNJy";
export var gridImageSubtitle = "styles-module--gridImageSubtitle--P_zFW";
export var gridImageContent = "styles-module--gridImageContent--2JzgM";